jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

// Function to replace text content with icons
function replaceWithIcon(selector, value, iconUrl) {
    const element = document.querySelector(`${selector}[data-value="${value}"]`);
    if (element) {
        const icon = document.createElement('img');
        icon.src = iconUrl;
        icon.alt = value;
        element.textContent = '';
        element.appendChild(icon);
    } else {
        console.log(`Element with data-value="${value}" not found.`);
    }
}

// Replace Rainuré by an icon
//replaceWithIcon('.t4s-swatch__item', 'Rainuré', 'https://img.icons8.com/?size=100&id=Zii4wCAaND93&format=png&color=000000');

// Replace Carré by another icon
//replaceWithIcon('.t4s-swatch__item', 'Carré', 'https://img.icons8.com/?size=100&id=Zii4wCAaND93&format=png&color=000000');

// Replace Fascia by another icon
//replaceWithIcon('.t4s-swatch__item', 'Fascia', 'https://cdn.shopify.com/s/files/1/0687/7259/3894/files/3_FASCIA_RISER-EDGE.svg?v=1716415371');



  

});